import axios from "axios";

export const loginUser = async (email, password) => {
  const { data, status } = await axios.post(
    "https://api.admin.meetserbia.rs/users/authenticate",
    {
      email,
      password,
    }
  );

  return { data, status };
};
